<div class="wrapper">
    <div class="card">

        <!-- Phone Number -->
        <div class="section">
            <label class="field-label" for="phone">Phone Number:</label>
            <input class="input" [class.error]="phoneError" id="phone" name="phone" type="tel"
                placeholder="+1 (555) 123-4567" autocomplete="tel" [(ngModel)]="phone"
                (ngModelChange)="onPhoneChange()" />
            <div class="field-error" *ngIf="phoneError">{{ phoneError }}</div>
        </div>

        <!-- SMS Consent -->
        <div class="section">
            <label class="consent-label" [class.error]="consentError" for="sms-consent">
                <input id="sms-consent" name="sms_consent" type="checkbox" [(ngModel)]="smsConsent"
                    (ngModelChange)="onConsentChange()" />
                <span class="consent-text">
                    By checking this box, you agree to receive SMS messages from
                    <strong>ENATIV</strong> for <strong>authentication and account security</strong>
                    purposes. Message and data rates may apply. Reply <strong>STOP</strong> to opt out.
                </span>
            </label>
            <div class="field-error" *ngIf="consentError">{{ consentError }}</div>
        </div>

        <!-- Submit -->
        <div class="submit-section">
            <button type="button" class="submit" [disabled]="submitting" (click)="onSubmit()">
                {{ submitting ? 'Sending…' : 'Submit' }}
            </button>
            <div class="success-msg" *ngIf="submitted">
                ✓ Thank you. Your consent has been recorded.
            </div>
        </div>

    </div>
</div>
